/**
 * Fornisce un observer per gestire le chiamate su evento in tutto il frontend
 */

const Observer = {
    events: {},
    subscribe: (tag, cb) => {
        Observer.events[tag] = (Observer.events[tag] || []).filter(C => C !== cb).concat(cb);
    },
    uniquesubscribe: (tag, cb) => {
        Observer.events[tag] = [cb];
    },
    unsubscribe: (tag, cb) => {
        Observer.events[tag] = (Observer.events[tag] || []).filter(C => C !== cb);
    },
    notify: (tag, data) => {
        (Observer.events[tag] || []).forEach(cb => cb(data, () => Observer.unsubscribe(tag, cb)));
    },
    monosubscribe: (tag, cb) => {
        Observer.events[tag] = (Observer.events[tag] || []).concat((data, unsubscribe) => unsubscribe(cb(data)));
    }
};

export default Observer;